import { BrandingImage } from "@bcm-dev/bcms-vite";
import { CenterContentContainer, PageContainer, PageContentView } from "components/shared";
import PageTitleView from "components/shared/views/PageTitleView";
import React from "react";

import "./styles.css";

/**
 * @function ViewStatementPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ViewStatementPage.
 */
export default function ViewStatementPage(props) {
    return (
        
        <PageContainer className="view-statement-page">
            <PageTitleView title="eStatement" leftIcon="LeftChevronIcon" rightIcon="ShareIcon" dataPoint="View_Statement_Header" />
            <PageContentView>
                <CenterContentContainer>
                    <BrandingImage id="statement_abi22" className="statement-image" />
                </CenterContentContainer>
            </PageContentView>
        </PageContainer>
 
    )
}